<a [href]="link"
   [attr.id]="id"
   class="ba-link-primary ba-link-linkout"
   [ngClass]="additionalClasses"
   [attr.target]="openNewTab ? '_blank' : null"
   [attr.rel]="openNewTab ? 'noopener noreferrer' : null">{{ linkText }}</a>
